import { render, staticRenderFns } from "./CollapseTreinamento.vue?vue&type=template&id=503bf770&scoped=true&"
import script from "./CollapseTreinamento.vue?vue&type=script&lang=js&"
export * from "./CollapseTreinamento.vue?vue&type=script&lang=js&"
import style0 from "./CollapseTreinamento.vue?vue&type=style&index=0&id=503bf770&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503bf770",
  null
  
)

export default component.exports